interface KPIItem {
  colorCode?: string
  count?: string
  countClass?: string
  link?:string
  sectionCode?:number
  title?: string
}
export const responseRequest :KPIItem[] = [
  {
    colorCode: '1',
    count: '00',
    countClass:
      'bgcolor-49 font-12 poppins-bold ms-auto p-2 poppins-bold font-15 m--1 border-top-right-radius border-bottom-right-radius',
    link: '#',
    sectionCode:1,
    title: 'Career Development',
  },
  {
    colorCode: '12',
    count: '00',
    countClass:
      'bgcolor-50 font-12 poppins-bold ms-auto  p-2 poppins-bold font-15 m--1 border-top-right-radius border-bottom-right-radius',
    link: '#',
    sectionCode:2,
    title: 'Customer Support',
  },
  {
    colorCode: '13',
    count: '00',
    countClass:
      'bgcolor-51 font-12 poppins-bold ms-auto  p-2 poppins-bold font-15 m--1 border-top-right-radius border-bottom-right-radius',
    link: '#',
    sectionCode:3,
    title: 'Force Management',
  },
  {
    colorCode: '14',
    count: '00',
    countClass:
      'bgcolor-52 font-12 poppins-bold ms-auto px-2 py-2 poppins-bold font-16 m--1 border-top-right-radius border-bottom-right-radius',
    link: '#',
    sectionCode:4,
    title: 'Installation Personnel Readiness',
  },
  {
    colorCode: '15',
    count: '00',
    countClass:
      'bgcolor-52 font-12 poppins-bold ms-auto  p-2 poppins-bold font-15 m--1 border-top-right-radius border-bottom-right-radius',
    link: '#',
    sectionCode:5, // This could potentially be 4 
    title: 'Personnel Systems Management',
  }
]

export const responsePending = [
  {
    colorCode: '1',
    count: '00',
    countClass:
      'bgcolor-49 font-12 poppins-bold ms-auto  p-2 poppins-bold font-15 m--1 border-top-right-radius border-bottom-right-radius',
    link: '#',
    sectionCode:1,
    title: 'Career Development',
  },
  {
    colorCode: '12',
    count:'00',
    countClass:
      'bgcolor-50 font-12 poppins-bold ms-auto  p-2 poppins-bold font-15 m--1 border-top-right-radius border-bottom-right-radius',
    link: '#',
    sectionCode:2,
    title: 'Customer Support',
  },

  {
    colorCode: '13',
    count: '00',
    countClass:
      'bgcolor-51 font-12 poppins-bold ms-auto  p-2 poppins-bold font-15 m--1 border-top-right-radius border-bottom-right-radius',
    link: '#',
    sectionCode:3,
    title: 'Force Management',
  },
  {
    colorCode: '14',
    count: '00',
    countClass:
      'bgcolor-52 font-12 poppins-bold ms-auto  p-2 poppins-bold font-15 m--1 border-top-right-radius border-bottom-right-radius',
    link: '#',
    sectionCode:4,
    title: 'Installation Personnel Readiness',
  },
  {
    colorCode: '15',
    count: '00',
    countClass:
      'bgcolor-52 font-12 poppins-bold ms-auto  p-2 poppins-bold font-15 m--1 border-top-right-radius border-bottom-right-radius',
    link: '#',
    sectionCode:5,
    title: 'Personnel Systems Management',
  }
]
